// import {
// 	memo,
// 	useCallback,
// 	useEffect,
// 	useMemo,
// 	useRef,
// 	useState,
// } from "react";

// import { Link } from "react-router-dom";

// import "./Home.css";
// import Navbar from "./Navbar/Navbar";
// import ExploreCollection from "./exploreCollection/ExploreCollection";
// import Collections from "./collections/Collections";
// import Features from "./Feature/Features";
// import Shapingd from "./shaping/ Shapingd";
// import Footer from "../Footer/Footer";
// import LoadingState from "../common/LoadingState";
// import { getProductImageUrl } from "../../utils/imageUrl";

// const SERVER_BASE_URL = "https://admin.monsinidress.com";
// const DEFAULT_YEAR = 2027;
// const HOME_CACHE_KEY = "azure-home-products-v2";
// const HOME_CACHE_MAX_AGE = 5 * 60 * 1000;

// const ChevronLeftIcon = () => (
// 	<svg
// 		viewBox="0 0 24 24"
// 		fill="none"
// 		stroke="currentColor"
// 		strokeWidth="2"
// 		strokeLinecap="round"
// 		strokeLinejoin="round"
// 		className="h-7 w-7"
// 		aria-hidden="true"
// 		focusable="false"
// 	>
// 		<path d="m15 18-6-6 6-6" />
// 	</svg>
// );

// const ChevronRightIcon = () => (
// 	<svg
// 		viewBox="0 0 24 24"
// 		fill="none"
// 		stroke="currentColor"
// 		strokeWidth="2"
// 		strokeLinecap="round"
// 		strokeLinejoin="round"
// 		className="h-7 w-7"
// 		aria-hidden="true"
// 		focusable="false"
// 	>
// 		<path d="m9 18 6-6-6-6" />
// 	</svg>
// );

// const ArrowRightIcon = () => (
// 	<svg
// 		viewBox="0 0 24 24"
// 		fill="none"
// 		stroke="currentColor"
// 		strokeWidth="2"
// 		strokeLinecap="round"
// 		strokeLinejoin="round"
// 		className="ml-5 hidden h-6 w-6 md:block"
// 		aria-hidden="true"
// 		focusable="false"
// 	>
// 		<path d="M5 12h14M13 6l6 6-6 6" />
// 	</svg>
// );

// function ProductSectionsLoading() {
// 	return (
// 		<section
// 			className="flex min-h-[220px] w-full items-center justify-center px-4 py-8"
// 			aria-label="Loading Azure collections"
// 		>
// 			<LoadingState
// 				label="Loading latest Azure collections..."
// 				description=""
// 				minHeight={180}
// 			/>
// 		</section>
// 	);
// }

// function getYearsFromProducts(products = []) {
// 	return [
// 		...new Set(
// 			products
// 				.map((item) => Number(item?.year))
// 				.filter(Number.isFinite)
// 		),
// 	].sort((a, b) => b - a);
// }

// function readHomeCache() {
// 	try {
// 		const raw = window.sessionStorage.getItem(HOME_CACHE_KEY);
// 		if (!raw) return null;

// 		const parsed = JSON.parse(raw);
// 		const savedAt = Number(parsed?.savedAt || 0);

// 		if (!savedAt || Date.now() - savedAt > HOME_CACHE_MAX_AGE) {
// 			window.sessionStorage.removeItem(HOME_CACHE_KEY);
// 			return null;
// 		}

// 		if (!Array.isArray(parsed?.products)) return null;

// 		return {
// 			products: parsed.products,
// 			years: Array.isArray(parsed?.years) ? parsed.years : [],
// 		};
// 	} catch {
// 		return null;
// 	}
// }

// function writeHomeCache(products, years) {
// 	try {
// 		window.sessionStorage.setItem(
// 			HOME_CACHE_KEY,
// 			JSON.stringify({
// 				products,
// 				years,
// 				savedAt: Date.now(),
// 			})
// 		);
// 	} catch {
// 		// Cache is optional. Ignore storage errors.
// 	}
// }

// async function fetchHomeProducts(signal) {
// 	const response = await fetch(`${SERVER_BASE_URL}/api/products/brand`, {
// 		method: "POST",
// 		headers: {
// 			"Content-Type": "application/json",
// 			Accept: "application/json",
// 		},
// 		body: JSON.stringify({
// 			brand: "Azure",
// 		}),
// 		signal,
// 	});

// 	if (!response.ok) {
// 		throw new Error(`Products request failed: ${response.status}`);
// 	}

// 	const result = await response.json();
// 	const products = Array.isArray(result?.data?.products)
// 		? result.data.products
// 		: [];

// 	const responseYears = Array.isArray(result?.data?.years)
// 		? result.data.years
// 		: [];

// 	const years =
// 		responseYears.length > 0
// 			? responseYears
// 			: getYearsFromProducts(products);

// 	return { products, years };
// }

// function Home() {
// 	const cachedHomeData = useMemo(() => readHomeCache(), []);

// 	const [data, setData] = useState(cachedHomeData?.products || []);
// 	const [years, setYears] = useState(
// 		cachedHomeData?.years?.length > 0
// 			? cachedHomeData.years
// 			: [DEFAULT_YEAR]
// 	);
// 	const [loading, setLoading] = useState(!cachedHomeData);
// 	const [error, setError] = useState("");
// 	const [retryKey, setRetryKey] = useState(0);

// 	useEffect(() => {
// 		let active = true;
// 		const controller = new AbortController();

// 		const fetchProducts = async () => {
// 			if (!cachedHomeData) {
// 				setLoading(true);
// 			}
// 			setError("");

// 			try {
// 				const { products, years: apiYears } = await fetchHomeProducts(
// 					controller.signal
// 				);

// 				if (!active) return;

// 				setData(products);

// 				if (apiYears.length > 0) {
// 					setYears(apiYears);
// 				}

// 				writeHomeCache(products, apiYears);
// 			} catch (fetchError) {
// 				if (!active || fetchError?.name === "AbortError") {
// 					return;
// 				}

// 				console.error("Azure homepage products request failed:", fetchError);

// 				// If cached data is already visible, keep it on screen and do not
// 				// replace the page with an error box.
// 				if (!cachedHomeData) {
// 					setError("Unable to load the latest Azure products right now.");
// 				}
// 			} finally {
// 				if (active) {
// 					setLoading(false);
// 				}
// 			}
// 		};

// 		// Start immediately. Do not wait for requestIdleCallback and do not
// 		// abort the API after 9 seconds. The old 9-second abort was the reason
// 		// the page showed "The product request took too long".
// 		fetchProducts();

// 		return () => {
// 			active = false;
// 			controller.abort();
// 		};
// 	}, [retryKey, cachedHomeData]);

// 	const latestYear = useMemo(() => {
// 		const numericYears = years
// 			.map((year) => Number(year))
// 			.filter(Number.isFinite);

// 		return numericYears.length > 0
// 			? Math.max(...numericYears)
// 			: DEFAULT_YEAR;
// 	}, [years]);

// 	const handleRetry = useCallback(() => {
// 		setRetryKey((current) => current + 1);
// 	}, []);

// 	return (
// 		<div className="relative overflow-hidden">
// 			<a
// 				href="#main-content"
// 				className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[2000] focus:rounded focus:bg-white focus:px-4 focus:py-2 focus:text-black focus:shadow"
// 			>
// 				Skip to main content
// 			</a>

// 			<Navbar />

// 			<main id="main-content">
// 				<ExploreCollection latestYear={latestYear} />

// 				{loading && data.length === 0 ? (
// 					<ProductSectionsLoading />
// 				) : error && data.length === 0 ? (
// 					<section className="mx-auto mb-16 max-w-xl px-4 text-center">
// 						<div
// 							className="rounded-lg border border-red-200 bg-red-50 p-6 text-red-800"
// 							role="alert"
// 						>
// 							<p className="font-semibold">{error}</p>
// 							<button
// 								type="button"
// 								onClick={handleRetry}
// 								className="mt-4 rounded bg-[#1f4c94] px-5 py-2 font-semibold text-white transition hover:bg-[#173d78]"
// 							>
// 								Try Again
// 							</button>
// 						</div>
// 					</section>
// 				) : data.length > 0 ? (
// 					<>
// 						<Collections data={data} latestYear={latestYear} />

// 						<TypeDress
// 							title="Shine Bright, Dance Bold."
// 							data={data}
// 						/>

// 						<TypeDress
// 							title="Forever Starts with You."
// 							data={data}
// 						/>

// 						<TypeDress
// 							title="Grace, Glamour, Timeless Beauty."
// 							data={data}
// 						/>

// 						<Features data={data} />
// 					</>
// 				) : null}

// 				<Shapingd />
// 			</main>

// 			<Footer />
// 		</div>
// 	);
// }

// const TypeDress = memo(function TypeDress({ title, data = [] }) {
// 	const scrollRef = useRef(null);

// 	const featuredData = useMemo(() => {
// 		if (!Array.isArray(data) || data.length === 0) {
// 			return [];
// 		}

// 		const availableYears = [
// 			...new Set(
// 				data
// 					.map((item) => Number(item?.year))
// 					.filter(Number.isFinite)
// 			),
// 		].sort((a, b) => b - a);

// 		const result = [];

// 		for (const year of availableYears) {
// 			for (const item of data) {
// 				if (result.length >= 6) {
// 					break;
// 				}

// 				if (item?.viewInfront === true && Number(item?.year) === year) {
// 					result.push(item);
// 				}
// 			}

// 			if (result.length >= 6) {
// 				break;
// 			}
// 		}

// 		return result;
// 	}, [data]);

// 	const scroll = useCallback((direction) => {
// 		const container = scrollRef.current;

// 		if (!container) {
// 			return;
// 		}

// 		const firstItem = container.firstElementChild;

// 		if (!firstItem) {
// 			return;
// 		}

// 		const nextItem = firstItem.nextElementSibling;
// 		const scrollAmount = nextItem
// 			? nextItem.offsetLeft - firstItem.offsetLeft
// 			: firstItem.offsetWidth + 16;

// 		container.scrollBy({
// 			left: direction === "left" ? -scrollAmount : scrollAmount,
// 			behavior: "smooth",
// 		});
// 	}, []);

// 	if (featuredData.length === 0) {
// 		return null;
// 	}

// 	return (
// 		<section className="relative mb-20 overflow-hidden" aria-label={title}>
// 			<div className="mb-20 text-center font-lora text-3xl font-semibold md:text-5xl">
// 				<h2>{title}</h2>
// 			</div>

// 			<button
// 				type="button"
// 				onClick={() => scroll("left")}
// 				aria-label={`Scroll ${title} left`}
// 				className="absolute left-4 top-[60%] z-10 -translate-y-1/2 rounded-full bg-[#1f4c94] p-2 text-white shadow-md transition hover:bg-[#173d78] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1f4c94] focus-visible:ring-offset-2"
// 			>
// 				<ChevronLeftIcon />
// 			</button>

// 			<div
// 				ref={scrollRef}
// 				className="no-scrollbar flex gap-3 overflow-x-auto scroll-smooth px-4"
// 			>
// 				{featuredData.map((item, index) => {
// 					const imageSource = getProductImageUrl(item, 0);

// 					return (
// 						<Link
// 							to={`/product/id/${item.style}`}
// 							state={{ product: item }}
// 							key={item?._id || item?.id || item?.style || index}
// 							className="group relative h-[400px] w-[350px] flex-shrink-0 overflow-hidden"
// 							aria-label={`View Azure style ${item.style}`}
// 						>
// 							<img
// 								src={imageSource}
// 								alt={`Azure dress ${item.style}`}
// 								loading="lazy"
// 								fetchPriority="low"
// 								decoding="async"
// 								width="350"
// 								height="400"
// 								className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
// 							/>

// 							<div className="absolute bottom-3 right-3 flex items-center justify-center rounded-md bg-[#1f4c94] px-3 py-1 font-lora text-md text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100 group-focus:opacity-100">
// 								{item.style}
// 								<ArrowRightIcon />
// 							</div>
// 						</Link>
// 					);
// 				})}
// 			</div>

// 			<button
// 				type="button"
// 				onClick={() => scroll("right")}
// 				aria-label={`Scroll ${title} right`}
// 				className="absolute right-4 top-[60%] z-10 -translate-y-1/2 rounded-full bg-[#1f4c94] p-2 text-white shadow-md transition hover:bg-[#173d78] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1f4c94] focus-visible:ring-offset-2"
// 			>
// 				<ChevronRightIcon />
// 			</button>
// 		</section>
// 	);
// });

// export default memo(Home);




import {
    memo,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";

import { Link } from "react-router-dom";

import "./Home.css";
import Navbar from "./Navbar/Navbar";
import ExploreCollection from "./exploreCollection/ExploreCollection";
import Collections from "./collections/Collections";
import Features from "./Feature/Features";
import Shapingd from "./shaping/ Shapingd";
import Footer from "../Footer/Footer";
import LoadingState from "../common/LoadingState";

const SERVER_BASE_URL = "https://admin.monsinidress.com";
const DEFAULT_YEAR = 2027;

const HOME_CACHE_KEY = "azure-home-products-v2";
const HOME_CACHE_MAX_AGE = 5 * 60 * 1000;

/* =========================================================
   ICONS
========================================================= */

const ChevronLeftIcon = () => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-7 w-7"
        aria-hidden="true"
        focusable="false"
    >
        <path d="m15 18-6-6 6-6" />
    </svg>
);

const ChevronRightIcon = () => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-7 w-7"
        aria-hidden="true"
        focusable="false"
    >
        <path d="m9 18 6-6-6-6" />
    </svg>
);

const ArrowRightIcon = () => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="ml-5 hidden h-6 w-6 md:block"
        aria-hidden="true"
        focusable="false"
    >
        <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
);

/* =========================================================
   LOADING
========================================================= */

function ProductSectionsLoading() {
    return (
        <section
            className="flex min-h-[220px] w-full items-center justify-center px-4 py-8"
            aria-label="Loading Azure collections"
        >
            <LoadingState
                label="Loading latest Azure collections..."
                description=""
                minHeight={180}
            />
        </section>
    );
}

/* =========================================================
   YEAR HELPER
========================================================= */

function getYearsFromProducts(products = []) {
    return [
        ...new Set(
            products
                .map((item) => Number(item?.year))
                .filter(Number.isFinite)
        ),
    ].sort((a, b) => b - a);
}

/* =========================================================
   CACHE
========================================================= */

function readHomeCache() {
    try {
        const raw = window.sessionStorage.getItem(HOME_CACHE_KEY);

        if (!raw) {
            return null;
        }

        const parsed = JSON.parse(raw);
        const savedAt = Number(parsed?.savedAt || 0);

        if (
            !savedAt ||
            Date.now() - savedAt > HOME_CACHE_MAX_AGE
        ) {
            window.sessionStorage.removeItem(HOME_CACHE_KEY);

            return null;
        }

        if (!Array.isArray(parsed?.products)) {
            return null;
        }

        return {
            products: parsed.products,
            years: Array.isArray(parsed?.years)
                ? parsed.years
                : [],
        };
    } catch {
        return null;
    }
}

function writeHomeCache(products, years) {
    try {
        window.sessionStorage.setItem(
            HOME_CACHE_KEY,
            JSON.stringify({
                products,
                years,
                savedAt: Date.now(),
            })
        );
    } catch {
        // Cache is optional
    }
}

/* =========================================================
   API
========================================================= */

async function fetchHomeProducts(signal) {
    const response = await fetch(
        `${SERVER_BASE_URL}/api/products/brand`,
        {
            method: "POST",

            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },

            body: JSON.stringify({
                brand: "Azure",
            }),

            signal,
        }
    );

    if (!response.ok) {
        throw new Error(
            `Products request failed: ${response.status}`
        );
    }

    const result = await response.json();

    const products = Array.isArray(result?.data?.products)
        ? result.data.products
        : [];

    const responseYears = Array.isArray(result?.data?.years)
        ? result.data.years
        : [];

    const years =
        responseYears.length > 0
            ? responseYears
            : getYearsFromProducts(products);

    return {
        products,
        years,
    };
}

/* =========================================================
   RANDOM PRODUCTS
   ---------------------------------------------------------
   IMPORTANT:
   - No duplicate style
   - No duplicate first image
   - Random order
   - Divided into 3 different groups
========================================================= */

function createRandomDressGroups(products = []) {
    if (!Array.isArray(products) || products.length === 0) {
        return [[], [], []];
    }

    const uniqueProducts = [];

    const usedStyles = new Set();
    const usedImages = new Set();

    /*
     * We intentionally DO NOT use:
     *
     * item.viewInfront === true
     *
     * because that was limiting these rows to the same
     * small group of products.
     */
    for (const item of products) {
        const style = String(
            item?.style || ""
        ).trim();

        const image = String(
            item?.images?.[0] || ""
        )
            .trim()
            .replace(/^\/+/, "");

        if (!style || !image) {
            continue;
        }

        const styleKey = style.toLowerCase();

        /*
         * Remove query string as well so URLs like:
         *
         * image.jpg?v=1
         * image.jpg?v=2
         *
         * are still considered the SAME image.
         */
        const imageKey = image
            .split("?")[0]
            .toLowerCase();

        if (
            usedStyles.has(styleKey) ||
            usedImages.has(imageKey)
        ) {
            continue;
        }

        usedStyles.add(styleKey);
        usedImages.add(imageKey);

        uniqueProducts.push(item);
    }

    /*
     * Fisher-Yates random shuffle
     */
    const shuffled = [...uniqueProducts];

    for (
        let i = shuffled.length - 1;
        i > 0;
        i--
    ) {
        const randomIndex = Math.floor(
            Math.random() * (i + 1)
        );

        const temp = shuffled[i];

        shuffled[i] = shuffled[randomIndex];
        shuffled[randomIndex] = temp;
    }

    /*
     * Maximum total:
     *
     * 6 × 3 sections = 18 products
     */
    const selectedProducts = shuffled.slice(0, 18);

    const groups = [
        [],
        [],
        [],
    ];

    /*
     * Round-robin distribution.
     *
     * Product 1 -> Section 1
     * Product 2 -> Section 2
     * Product 3 -> Section 3
     * Product 4 -> Section 1
     * etc.
     *
     * This guarantees the same selected product/image
     * does NOT appear in another section.
     */
    selectedProducts.forEach((product, index) => {
        const groupIndex = index % 3;

        groups[groupIndex].push(product);
    });

    return groups;
}

/* =========================================================
   HOME
========================================================= */

function Home() {
    const cachedHomeData = useMemo(
        () => readHomeCache(),
        []
    );

    const [data, setData] = useState(
        cachedHomeData?.products || []
    );

    const [years, setYears] = useState(
        cachedHomeData?.years?.length > 0
            ? cachedHomeData.years
            : [DEFAULT_YEAR]
    );

    const [loading, setLoading] = useState(
        !cachedHomeData
    );

    const [error, setError] = useState("");

    const [retryKey, setRetryKey] =
        useState(0);

    /*
     * Three completely separate random groups.
     */
    const [
        randomDressGroups,
        setRandomDressGroups,
    ] = useState([
        [],
        [],
        [],
    ]);

    /* =====================================================
       FETCH PRODUCTS
    ===================================================== */

    useEffect(() => {
        let active = true;

        const controller =
            new AbortController();

        const fetchProducts = async () => {
            if (!cachedHomeData) {
                setLoading(true);
            }

            setError("");

            try {
                const {
                    products,
                    years: apiYears,
                } = await fetchHomeProducts(
                    controller.signal
                );

                if (!active) {
                    return;
                }

                setData(products);

                if (apiYears.length > 0) {
                    setYears(apiYears);
                }

                writeHomeCache(
                    products,
                    apiYears
                );
            } catch (fetchError) {
                if (
                    !active ||
                    fetchError?.name ===
                        "AbortError"
                ) {
                    return;
                }

                console.error(
                    "Azure homepage products request failed:",
                    fetchError
                );

                if (!cachedHomeData) {
                    setError(
                        "Unable to load the latest Azure products right now."
                    );
                }
            } finally {
                if (active) {
                    setLoading(false);
                }
            }
        };

        fetchProducts();

        return () => {
            active = false;

            controller.abort();
        };
    }, [
        retryKey,
        cachedHomeData,
    ]);

    /* =====================================================
       CREATE RANDOM GROUPS

       This runs when product data arrives.

       Randomization happens in an effect, not directly
       during JSX rendering.
    ===================================================== */

    useEffect(() => {
        if (
            !Array.isArray(data) ||
            data.length === 0
        ) {
            setRandomDressGroups([
                [],
                [],
                [],
            ]);

            return;
        }

        const groups =
            createRandomDressGroups(data);

        setRandomDressGroups(groups);
    }, [data]);

    /* =====================================================
       LATEST YEAR
    ===================================================== */

    const latestYear = useMemo(() => {
        const numericYears = years
            .map((year) => Number(year))
            .filter(Number.isFinite);

        return numericYears.length > 0
            ? Math.max(...numericYears)
            : DEFAULT_YEAR;
    }, [years]);

    /* =====================================================
       RETRY
    ===================================================== */

    const handleRetry = useCallback(() => {
        setRetryKey(
            (current) => current + 1
        );
    }, []);

    /* =====================================================
       RENDER
    ===================================================== */

    return (
        <div className="relative overflow-hidden">
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[2000] focus:rounded focus:bg-white focus:px-4 focus:py-2 focus:text-black focus:shadow"
            >
                Skip to main content
            </a>

            <Navbar />

            <main id="main-content">
                <ExploreCollection
                    latestYear={latestYear}
                />

                {loading &&
                data.length === 0 ? (
                    <ProductSectionsLoading />
                ) : error &&
                  data.length === 0 ? (
                    <section className="mx-auto mb-16 max-w-xl px-4 text-center">
                        <div
                            className="rounded-lg border border-red-200 bg-red-50 p-6 text-red-800"
                            role="alert"
                        >
                            <p className="font-semibold">
                                {error}
                            </p>

                            <button
                                type="button"
                                onClick={
                                    handleRetry
                                }
                                className="mt-4 rounded bg-[#1f4c94] px-5 py-2 font-semibold text-white transition hover:bg-[#173d78]"
                            >
                                Try Again
                            </button>
                        </div>
                    </section>
                ) : data.length > 0 ? (
                    <>
                        {/* =================================================
                            EXISTING COLLECTION SECTION
                        ================================================= */}

                        <Collections
                            data={data}
                            latestYear={
                                latestYear
                            }
                        />

                        {/* =================================================
                            RANDOM SECTION 1
                        ================================================= */}

                        <TypeDress
                            title="Shine Bright, Dance Bold."
                            data={
                                randomDressGroups[0]
                            }
                        />

                        {/* =================================================
                            RANDOM SECTION 2
                        ================================================= */}

                        <TypeDress
                            title="Forever Starts with You."
                            data={
                                randomDressGroups[1]
                            }
                        />

                        {/* =================================================
                            RANDOM SECTION 3
                        ================================================= */}

                        <TypeDress
                            title="Grace, Glamour, Timeless Beauty."
                            data={
                                randomDressGroups[2]
                            }
                        />

                        <Features
                            data={data}
                        />
                    </>
                ) : null}

                <Shapingd />
            </main>

            <Footer />
        </div>
    );
}

/* =========================================================
   TYPE DRESS
========================================================= */

const TypeDress = memo(
    function TypeDress({
        title,
        data = [],
    }) {
        const scrollRef =
            useRef(null);

        /*
         * IMPORTANT:
         *
         * NO filtering here.
         * NO viewInfront here.
         * NO randomization here.
         *
         * Home already gives this section its own
         * completely separate random products.
         */
        const featuredData =
            useMemo(() => {
                if (
                    !Array.isArray(data)
                ) {
                    return [];
                }

                return data.slice(0, 6);
            }, [data]);

        /* =================================================
           SLIDER
        ================================================= */

        const scroll =
            useCallback(
                (direction) => {
                    const container =
                        scrollRef.current;

                    if (!container) {
                        return;
                    }

                    const firstItem =
                        container.firstElementChild;

                    if (!firstItem) {
                        return;
                    }

                    const nextItem =
                        firstItem.nextElementSibling;

                    const scrollAmount =
                        nextItem
                            ? nextItem.offsetLeft -
                              firstItem.offsetLeft
                            : firstItem.offsetWidth +
                              16;

                    container.scrollBy({
                        left:
                            direction ===
                            "left"
                                ? -scrollAmount
                                : scrollAmount,

                        behavior:
                            "smooth",
                    });
                },
                []
            );

        if (
            featuredData.length ===
            0
        ) {
            return null;
        }

        return (
            <section
                className="relative mb-20 overflow-hidden"
                aria-label={title}
            >
                {/* =========================================
                    TITLE
                ========================================= */}

                <div className="mb-20 text-center font-lora text-3xl font-semibold md:text-5xl">
                    <h2>
                        {title}
                    </h2>
                </div>

                {/* =========================================
                    LEFT BUTTON
                ========================================= */}

                <button
                    type="button"
                    onClick={() =>
                        scroll("left")
                    }
                    aria-label={`Scroll ${title} left`}
                    className="absolute left-4 top-[60%] z-10 -translate-y-1/2 rounded-full bg-[#1f4c94] p-2 text-white shadow-md transition hover:bg-[#173d78] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1f4c94] focus-visible:ring-offset-2"
                >
                    <ChevronLeftIcon />
                </button>

                {/* =========================================
                    PRODUCTS
                ========================================= */}

                <div
                    ref={scrollRef}
                    className="no-scrollbar flex gap-3 overflow-x-auto scroll-smooth px-4"
                >
                    {featuredData.map(
                        (
                            item,
                            index
                        ) => {
                            const imagePath =
                                String(
                                    item
                                        ?.images?.[0] ||
                                        ""
                                ).replace(
                                    /^\/+/,
                                    ""
                                );

                            const imageSource =
                                `${SERVER_BASE_URL}/${imagePath}`;

                            return (
                                <Link
                                    to={`/product/id/${item.style}`}
                                    state={{
                                        product:
                                            item,
                                    }}
                                    key={
                                        item?._id ||
                                        item?.id ||
                                        item?.style ||
                                        index
                                    }
                                    className="group relative h-[400px] w-[350px] flex-shrink-0 overflow-hidden"
                                    aria-label={`View Azure style ${item.style}`}
                                >
                                    <img
                                        src={
                                            imageSource
                                        }
                                        alt={`Azure dress ${item.style}`}
                                        loading="lazy"
                                        fetchPriority="low"
                                        decoding="async"
                                        width="350"
                                        height="400"
                                        className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                                    />

                                    <div className="absolute bottom-3 right-3 flex items-center justify-center rounded-md bg-[#1f4c94] px-3 py-1 font-lora text-md text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100 group-focus:opacity-100">
                                        {
                                            item.style
                                        }

                                        <ArrowRightIcon />
                                    </div>
                                </Link>
                            );
                        }
                    )}
                </div>

                {/* =========================================
                    RIGHT BUTTON
                ========================================= */}

                <button
                    type="button"
                    onClick={() =>
                        scroll("right")
                    }
                    aria-label={`Scroll ${title} right`}
                    className="absolute right-4 top-[60%] z-10 -translate-y-1/2 rounded-full bg-[#1f4c94] p-2 text-white shadow-md transition hover:bg-[#173d78] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1f4c94] focus-visible:ring-offset-2"
                >
                    <ChevronRightIcon />
                </button>
            </section>
        );
    }
);

export default memo(Home);